<template>
  <div class="modal">
    <div class="modal-content select-category-modal">
      <p class="btn" v-on:click="handleSubmit(null)">x</p>
      <form @submit.prevent>
        <input type="text" id="selectCustomerTypeModelSearchInput" v-model="search" class="input" placeholder="Search Customer Type">
      </form>
      <div class="category-list">
          <div>
              
          </div>
        <div 
          v-for="item in customerTypes.data" 
          :key="item._id"
          v-on:click="handleSubmit(item)"
          class="category btn"
        >
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['closeModal', 'onSubmit'],
  data() {
    return {
        searchTimeout: null,
        search: ''
    }
  },
  watch: {
    search: function() {
        this.searchTimeout && clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(
            () => this.getCustomerTypes(), 500
        )
    },
  },
  mounted() {
      this.getCustomerTypes();
  },
  methods: {
    handleSubmit(customerType) {
        // this.$store.dispatch("customerTypesModule/clearCustomerTypes");
        this.onSubmit(customerType)
        this.closeModal()
    },
    getCustomerTypes: function() {
        this.$store.dispatch("customerTypeModule/getCustomerType", {
            roles: this.roles,
            query: {
                search: this.search,
            }
        });
    }
  },
  computed: {
    customerTypes() {
        return this.$store.state.customerTypeModule.customerType;
    }
  }
}
</script>

<style>

</style>